import React from "react";
import {Link} from "react-router-dom";
import BannerApiComponent from "../../airports/p11v5-nsru-backend/web-services/BannerApiComponent";

class Banner extends React.Component
{
    constructor(props) {
        super(props);
        this.storageKey = "data-banner-" + this.props.id;
        this.className = "";

        let banner = []

        if(localStorage.getItem(this.storageKey))
        {
            banner = JSON.parse(localStorage.getItem(this.storageKey))
            this.state = {
                description: banner.description,
                image: process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + banner.file,
                link: banner.link
            }
        } else {
            this.state = {
                description: "",
                image: require("assets/img/app-icon/icon-default.png"),
                link: "#"
            }
        }

    }

    componentDidMount() {
        // โหลด API จากระบบจัดการ
        let bannerAPI = new BannerApiComponent();
        bannerAPI.show(this.props.id, res => {
            let banner = res.data.data;
            localStorage.setItem(this.storageKey, JSON.stringify(banner))
            this.setState({
                description: banner.description,
                image: process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + banner.file,
                link: banner.link
            })
        })
    }

    render() {
        return (
            <div className={"banner" + this.className}>
                <Link to={(this.state.link ?? "#")} target={this.props.appTarget ?? "_blank"}>
                    <img src={this.state.image}/>
                </Link>
            </div>
        );
    }
}

export default Banner;
